import { render, staticRenderFns } from "./ProfileRootPage.vue?vue&type=template&id=4ae2504a&scoped=true&"
import script from "./ProfileRootPage.vue?vue&type=script&lang=js&"
export * from "./ProfileRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae2504a",
  null
  
)

export default component.exports